import styled from 'styled-components'

import useUser from '@/hooks/useUser'
import type { AccountantReferee } from '@/lib/apollo/query/get-accountant-referee'
import type { EmployerReferee } from '@/lib/apollo/query/get-employer-referee'
import type { LandlordReferee } from '@/lib/apollo/query/get-landlord-referee'

import BotAccess from './BotAccess'
import Developer from './DeveloperTools'
import SendEmailAction from './SendEmail'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 20px;
  align-items: center;
`

type RefereeType = 'employer' | 'accountant' | 'landlord'

interface Props {
  refereeType: RefereeType
  referee: EmployerReferee | AccountantReferee | LandlordReferee
}

const RefereeActionButtons = ({ referee, refereeType }: Props) => {
  const { isDeveloperModeEnabled } = useUser()

  return (
    <Container>
      <>
        <BotAccess
          applicationId={referee.applicationId}
          customerId={referee.customerId}
          subjectId={referee.id}
          isReferee
        />
        {refereeType !== 'landlord' && (
          <SendEmailAction
            customerId={referee.customerId}
            applicationId={referee.applicationId}
            subjectId={referee.id}
            subjectType={refereeType}
          />
        )}
        {isDeveloperModeEnabled && (
          <Developer
            customerId={referee.customerId}
            applicationId={referee.applicationId}
            subjectId={referee.id}
          />
        )}
      </>
    </Container>
  )
}

export default RefereeActionButtons
